import React from "react";
import { styled } from "@mui/material/styles";

import { Typography, Button, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import useShopContext from "@hooks/useShopContext";
import { updateResponses } from "../utils/questionUtils";
import { prefixCurrency } from "@common/utils/currency";

const PREFIX = "MultiSelectOption";

const classes = {
  option: `${PREFIX}-option`,
  checkBoxIcon: `${PREFIX}-checkBoxIcon`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
  gap: theme.spacing(0.5),
  display: "flex",
  alignItems: "center",
  borderRadius: "5px",
  justifyContent: "flex-start",
  backgroundColor: "#FFF",
  border: theme.bordered ? `1px solid ${theme.palette.secondary.main}` : "none",
  boxShadow: theme.bordered ? "none" : theme.shadows[2],
  margin: "5px 0",
  "&:hover": {
    backgroundColor: theme.palette.grey[100],
    boxShadow: theme.bordered ? "none" : theme.shadows[3],
  },
  "&:disabled": {
    backgroundColor: theme.palette.grey[300],
  },

  [`& .${classes.checkBoxIcon}`]: {
    color: theme.palette.accent.main,
  },
}));

const MultiSelectOption = ({ values, option, responses, setResponses, qnNum, disabled }) => {
  const { vendor } = useShopContext();

  const active = values.selected_options
    ? values.selected_options.filter((v) => v.text === option.text).length > 0
    : false;

  const updateValues = () => {
    if (active) {
      const newValues = values.selected_options.filter((v) => option.text !== v.text);
      updateResponses(newValues, responses, setResponses, qnNum);
    } else {
      if (values.selected_options) {
        updateResponses([...values.selected_options, option], responses, setResponses, qnNum);
      } else {
        updateResponses([option], responses, setResponses, qnNum);
      }
    }
  };

  return (
    <StyledButton onClick={updateValues} disableRipple disabled={!active && disabled}>
      <Checkbox
        sx={{ p: 0 }}
        checkedIcon={<CheckBoxIcon className={classes.checkBoxIcon} />}
        icon={<CheckBoxOutlineBlankIcon className={classes.checkBoxIcon} />}
        color="primary"
        checked={active}
        onChange={updateValues}
      />
      <div style={{ flex: 1, textAlign: "left" }}>
        <Typography
          variant="body1"
          sx={{
            textTransform: "None",
            color: (theme) => theme.palette.common.black,
            lineHeight: 1.1,
          }}
        >
          {option.text}
        </Typography>
      </div>
      <div style={{ textAlign: "right" }}>
        <Typography variant="body1" sx={{ color: (theme) => theme.palette.success.main }}>
          {option.price && `+${prefixCurrency(option.price, vendor)}`}
        </Typography>
      </div>
    </StyledButton>
  );
};

export default MultiSelectOption;
